import { render } from "./BlogRightSidebarPage.vue?vue&type=template&id=5b1e49a5"
import script from "./BlogRightSidebarPage.vue?vue&type=script&lang=js"
export * from "./BlogRightSidebarPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__